<script>
    export let checkedCombos;
    export let onChangeCheckedCombos;

    let isCollapsed = false;
</script>

<button class="config-button" on:click={() => (isCollapsed = !isCollapsed)}>
    <p>Configura tu izzi combo</p>
    <svg class="icon {!isCollapsed && 'is-rotated'}" aria-hidden="true"
        ><use xlink:href="/assets/img/icons/symbol-defs.svg#icon-angle-left"
        ></use></svg
    >
</button>
{#if !isCollapsed}
    <div class="config-box-container" style="display: flex">
        <button
            class="service-item service-item-fixed-height {!checkedCombos &&
                'service-item-active-blue'}"
            on:click={() => onChangeCheckedCombos(!checkedCombos)}
        >
            {#if !checkedCombos}
                <div class="offer-option-check">
                    <img
                        src="/assets/img/icons/check-option-blue.svg"
                        alt="móvil"
                    />
                </div>
            {/if}
            <p class="">sin streamings</p>
        </button>
        <button
            class="service-item service-item-fixed-height {checkedCombos &&
                'service-item-active-blue'}"
            on:click={() => onChangeCheckedCombos(!checkedCombos)}
        >
            {#if checkedCombos}
                <div class="offer-option-check">
                    <img
                        src="/assets/img/icons/check-option-blue.svg"
                        alt="móvil"
                    />
                </div>
            {/if}
            <p class="">con streamings</p>
        </button>
    </div>
{/if}
